import type { ReactNode } from 'react';
import { Provider } from 'jotai';

import { useUserContext } from 'src/components/app/context/UserContext';

/**
 * This component makes sure that the global store resets after the user changes.
 */
export const AtomProvider = ({ children }: { children: ReactNode }) => {
  const { user } = useUserContext();
  const userId = user ? user.id : null;

  return <Provider key={userId}>{children}</Provider>;
};

export default AtomProvider;
